module.exports = __webpack_public_path__ + "img/Celular.9b910025.svg";